import "./LoadingPage.scss";

export interface LoadingPageProps {}

const LoadingPage = () => {
  return <div className="LoadingPage-root"></div>;
};

export { LoadingPage };
